import React, { Component } from 'react';
import { Card, CardBody,
     Col, CardHeader, Badge, Row, Table, ModalHeader, Button } from 'reactstrap';
     
import ReactDOM from 'react-dom';

import {connect} from 'react-redux'
import TextInputComponent from '../../Components/TextInputComponent';
import QueryableAreaComponent from '../../Components/QueryableAreaComponent';
import AddBlockTitle from '../../Components/AddBlockTitle';
import { Routes } from '../../Services/API';
import { GetListAttempt_ACTION, AddObjectAttempt_ACTION, AddFileAttempt_ACTION, GetListObjectAttemptPost_ACTION, GetMultipleListAttempt_ACTION } from '../../Actions/LogisticActions';
import NameComponent from '../../Components/NameComponent';
import SearchingTitleComponent from '../../Components/SearchingTitleComponent';
import AddButtonComponent from '../../Components/AddButtonComponent';
import ModalComponent from '../../Components/ModalComponent';
import { VALID_IMAGE_EXTENSIONS, GetFileExtension, CreateChuck, VALID_PDF_EXTENSIONS, VALID_VIDEO_EXTENSIONS, CheckOwnership } from '../../Services/Utilities';
import FileInputComponent from '../../Components/FileInputComponent';
import LineComponent from '../../Components/LineComponent';
import SearchQuestionsComponent from '../../Components/SearchQuestionsComponent';
import QuestionLineViewComponent from '../../Components/QuestionLineViewComponent';
import LatexViewComponent from '../../Components/LatexViewComponent';
import ImageTreeNode from '../../Components/ImageTreeNode';
import InterpretedImageNode from '../../Components/InterpretedImageNode';
import { Input } from '@material-ui/core';

//constants
class StudentQuestionList extends Component {

   constructor(props){
       super(props)

       this.state = {
        
       }


   }


  componentDidMount(){
      if(!this.props.location.state){

          return
      }
     this.props.GetQuestions(this.props.location.state.values)
  }

  render() {
    

    return (
      <div className="animated fadeIn"  ref = {'Base_Div'}>
         

        <Row>
          <Col xl={12}>
            <Card>
               <CardHeader>
               <i className="fa fa-user-circle-o"></i> 
                    Questions
               </CardHeader>
               <CardBody>
               <hr/>
              {(this.props.IsSearching  || this.props.GetError)? 
                <SearchingTitleComponent  error = {this.props.GetError} OnError = {() => this.props.GetQuestions()}/>
                : 
                (this.props.Questions ?
                    <div style = {{flexDirection:'column', display:'flex'}}>
                                  {this.props.Questions.ClickableQuestions
                                  .filter((C) => this.state.GetOwnedTrees ? CheckOwnership(C, this.props.Name) : true)
                                  .filter((q) => {

                                    if(!this.state.SearchCode){
                                        return q
                                    }

                                    if(
                                    q.Code.toUpperCase().includes(this.state.SearchCode.toUpperCase())
                                    ){
                                        return q
                                    }

                                    }).map((q,i) => 
                                    <div key = {i}>
                                       <div style = {{flexDirection:'row', display:'flex'}}>
                                            <div style = {{width:40, marginRight:10}} onClick = {() => {
  
                                            }}>
                                                <NameComponent text = {i+1} backgroundColor = {'green'} textColor = {"white" }/>
                                            </div>
                                            <QuestionLineViewComponent
                                                Name = {q.Code} 
                                                URL = {q.BackgroundImageURL}
                                                width = {q.BackgroundImageWidth}
                                                height = {q.BackgroundImageHeight}
                                            />
                                            <Col xs = {4} style = {{flexDirection:'column', display:'flex',
                                                    alignItems:'left', alignContent:'left',
                                                    border:1, borderStyle:'dashed', borderColor:'#bfbfbf', 
                                                    width:'100%', margin:3}}>
                                                <Row style = {{flexDirection:'column', display:'flex',
                                                        alignItems:'left', alignContent:'left',
                                                        borderBottom:1, borderBottomStyle:'dashed', borderBottomColor:'#bfbfbf', 
                                                        width:'100%', margin:3}}>
                                                        <h5 style = {{cursor:'pointer'}} onClick = {() => {
                                                            
                                                            }}>
                                                               {q.AddedByName}
                                                        </h5>
                                                </Row>
                                                <Row style = {{flexDirection:'row', display:'flex',
                                                        alignItems:'left', alignContent:'left',
                                                        borderBottom:1, borderBottomStyle:'dashed', borderBottomColor:'#bfbfbf', 
                                                        width:'100%', margin:3}}>
                                                        <Col xs = {4}>
                                                            <h5 style = {{color:q.LevelOfDifficulty.HexColor}} onClick = {() => {
                                                                    
                                                                }}>
                                                                    {q.LevelOfDifficulty.Name}
                                                            </h5>
                                                        </Col>
                                                        
                                                </Row>
                                                <Row style = {{flexDirection:'column', display:'flex',
                                                        alignItems:'left', alignContent:'left',
                                                        borderBottom:1, borderBottomStyle:'dashed', borderBottomColor:'#bfbfbf', 
                                                        width:'100%', margin:3}}>
                                                        <h5  onClick = {() => {
                                                            
                                                            }}>
                                                                {q.Public ? "Public" : "Private"}
                                                        </h5>
                                                </Row>
                                                {q.PDFURL || q.VIDEOURL ? <Row style = {{flexDirection:'row', display:'flex',
                                                        alignItems:'left', alignContent:'left',
                                                        width:'100%', margin:3}}>
                                                    <Col xs = {3}>
                                                    {q.PDFURL  ? 
                                                    
                                                    <h4 style = {{cursor:'pointer', color:'white', backgroundColor:'red', fontWeight:'bold', textAlign:'center', borderRadius:20}} 
                                                    onClick = {() => {
                                                              window.open(q.PDFURL)  
                                                            }}>
                                                            PDF
                                                        </h4> : <div />}
                                                    </Col>
                                                    <Col xs = {3}>
                                                        {q.VIDEOURL ? <h4 style = {{cursor:'pointer', color:'white', backgroundColor:'#0086b3', fontWeight:'bold', textAlign:'center', borderRadius:20}} 
                                                        onClick = {() => {
                                                            window.open(q.VIDEOURL)  
                                                          }}
                                                        >
                                                            Video
                                                        </h4> : <div/>}
                                                    </Col>
                                                </Row> : <div />}
                                            </Col>
                                            <Col xs = {2}  >
                                                <Row style = {{flexDirection:'column', display:'flex',
                                                    alignItems:'left', alignContent:'left',
                                                    borderBottom:1, borderBottomStyle:'dashed', borderBottomColor:'#bfbfbf', 
                                                    width:'100%', margin:3}}>
                                                    <h3 >
                                                            <Badge color="primary" style = {{cursor:'pointer'}} onClick = {() => {
                                                            
                                                        }}>Play</Badge>
                                                    </h3>
                                                </Row>
                                                
                                            </Col>
                                       </div>
                                        <LineComponent  Color = "#009900"/>
                                    </div>)}
                                </div>
                    : <div />)
                }
               </CardBody>
            </Card>
          </Col>
        </Row>

      </div>
    )
  }

  
}


//
const QUESTIONS_SEARCHING_PARAMETER = 'IsCQuestionsSearching'

const QUESTIONS_DATA_PARAMETER = 'CQuestions'

const QUESTIONS_GET_ERROR_PARAMETER = 'CQuestionsGetError'


function MapStateToProps(state) {
    return {
        IsSearching: state.Query[QUESTIONS_SEARCHING_PARAMETER],
        Questions: state.Query[QUESTIONS_DATA_PARAMETER],
        GetError: state.Query[QUESTIONS_GET_ERROR_PARAMETER],

        Name: state.Authorization.name
    }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        
        GetQuestions: (values) => {dispatch(GetListObjectAttemptPost_ACTION({
            SearchParameter: QUESTIONS_SEARCHING_PARAMETER,
            DataParameter: QUESTIONS_DATA_PARAMETER,
            GetErrorParameter: QUESTIONS_GET_ERROR_PARAMETER,
            Path: Routes.GetQuestionsSearch,
            Body: values,
    
            [QUESTIONS_SEARCHING_PARAMETER]: true,
            
            [QUESTIONS_DATA_PARAMETER]: [],
    
            [QUESTIONS_GET_ERROR_PARAMETER]: ''
        }))}        
      }
  }
  
export default connect(MapStateToProps, MapDispatchToProps)(StudentQuestionList)

